import { createRouter as _createRouter, createWebHistory } from 'vue-router'

import { useOnboardingFooter } from '@/composables/useOnboardingFooter'

import admin from './admin.js'
import auth from './auth.js'
import dash from './dash.js'
import errors from './errors.js'
import onboarding from './onboarding.js'
import print from './print.js'
import publicRoutes from './public.js'

function createRouter() {
  const router = _createRouter({
    history: createWebHistory(),
    scrollBehavior() {
      // always scroll to top
      return { top: 0 }
    },
    linkActiveClass: 'active',
    routes: [...admin, ...auth, ...onboarding, ...dash, ...print, ...publicRoutes, ...errors],
  })

  // O footer do onboarding (useOnboardingFooter) é um estado reativo único
  // compartilhado por todas as telas do fluxo, sem reset automático na troca
  // de rota. Sem isso, uma tela que não declara `next.hidden`/`disabled`/
  // `loading` explicitamente herda o valor deixado pela tela anterior (bug
  // real: OnboardingStart esconde o botão "Continuar" e OnboardingInstructions
  // herdava esse estado, ficando sem o botão).
  router.beforeEach(to => {
    if (to.path.startsWith('/onboarding/')) {
      useOnboardingFooter().resetFooter()
    }
  })

  return router
}

export const router = createRouter()
